<div class="hospital-search__form" [ngClass]="{ loading: loading, largeSearch: largeSearch }">
  <form #hospitalSearchForm="ngForm" (ngSubmit)="onSubmit()">
    @if (loading) {
      <div class="loader-holder">
        <div class="ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p class="loader-text">
          <slot></slot>
        </p>
      </div>
    }

    <label [for]="'zipCode' + uniqueId" [ngClass]="{hideTitle: !showTitle}">Please Enter Your Zip Code</label>
    <div class="input-wrap">
      <input
        [id]="'zipCode' + uniqueId"
        [name]="'zipCode' + uniqueId"
        type="search"
        inputmode="numeric"
        required
        minlength="5"
        maxlength="5"
        pattern="[0-9]*"
        [(ngModel)]="zipCode"
        #zipCodeInput="ngModel"
        (keypress)="onKeyPress()"
        [placeholder]="largeSearch ? 'Input Billing Zip Code' : ''"
        />

      <button type="submit">Search</button>
    </div>

    @if (zipCodeInput.invalid && zipCodeInput.touched) {
      <div
        class="hospital-search__error"
        >
        @if (zipCodeInput.errors?.required) {
          <div>
            {{ "VALIDATION_ZIP_REQUIRED" | translate }}
          </div>
        } @else {
          <div>{{ "VALIDATION_ZIP_FORMAT" | translate }}</div>
        }
      </div>
    }
  </form>

  <!-- We only want to show this section if the form has been submitted. -->
  @if (this.submitted) {
    <div>
      @if (
        this?.hospital?.displayName || this?.hospital?.hospitalName; as name) {
        <p
          class="search-result"
          >
          Your donation will benefit <span>{{ name }}</span>.
        </p>
      } @else {
        <p>
          {{ "HOSPITAL_SEARCH_NOT_FOUND" | translate }}
        </p>
      }
    </div>
  }
</div>
